import { render } from "./header-menu.vue?vue&type=template&id=60876e28&scoped=true"
import script from "./header-menu.vue?vue&type=script&lang=js"
export * from "./header-menu.vue?vue&type=script&lang=js"

import "./header-menu.vue?vue&type=style&index=0&id=60876e28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60876e28"]])

export default __exports__